import { render, staticRenderFns } from "./zongdzf.vue?vue&type=template&id=0514221f&scoped=true&"
import script from "./zongdzf.vue?vue&type=script&lang=js&"
export * from "./zongdzf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0514221f",
  null
  
)

export default component.exports